export default __webpack_public_path__ + "static/media/002-ankylosaurus.6eded598.svg";